var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tooltipImg)?_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({
    customClass: 'tooltipContainer',
    trigger: 'hover',
    title: 'Favorilere Ekle',
    html: true,
    placement: 'top',
  }),expression:"{\n    customClass: 'tooltipContainer',\n    trigger: 'hover',\n    title: 'Favorilere Ekle',\n    html: true,\n    placement: 'top',\n  }"}],staticClass:"btn shadow-none border-none",class:_vm.tooltipClass,attrs:{"type":"button"},on:{"click":function($event){return _vm.clickEvent($event)}}},[_c('img',{attrs:{"src":require('../../../public/src/images/' + _vm.tooltipBtnImg),"alt":_vm.tooltipBtnImg}}),_vm._v("\n  "+_vm._s(_vm.tooltipBtnTitle)+"\n")]):_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({
    customClass: 'tooltipContainer',
    trigger: 'hover',
    title: 'Favorilere Ekle',
    html: true,
    placement: 'top',
  }),expression:"{\n    customClass: 'tooltipContainer',\n    trigger: 'hover',\n    title: 'Favorilere Ekle',\n    html: true,\n    placement: 'top',\n  }"}],staticClass:"btn",class:_vm.tooltipClass,attrs:{"type":"button"},on:{"click":function($event){return _vm.clickEvent($event)}}},[_vm._v("\n  "+_vm._s(_vm.tooltipBtnTitle)+"\n")])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }